module.exports = __webpack_public_path__ + "img/horizontal.349ff961.png";